import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { 
  Wrench, 
  Droplets, 
  CircleSlash, 
  CircleDot, 
  Zap, 
  Box, 
  Volume2, 
  Shield, 
  Sparkles,
  FileText,
  Calendar,
  Gauge,
  CheckCircle,
  XCircle,
  Printer,
  Languages,
  Camera
} from "lucide-react";
import jsPDF from "jspdf";
import { AIMechanicButton } from "./AITools";

// ==================== TRANSLATIONS ====================
const LANGS = {
  ro: {
    code: "ro",
    label: "Română",
    dir: "ltr",
    // Rating labels
    rating_0: "Non verificat / Lipsă",
    rating_1: "Defect / De înlocuit",
    rating_2: "De reparat",
    rating_3: "Funcțional",
    rating_4: "Stare bună",
    rating_5: "Excelent",
    // UI
    legend: "Legendă evaluare",
    comment_placeholder: "Comentariu...",
    service_info: "INFORMAȚII SERVICE",
    last_oil_change: "Ultimul schimb ulei efectuat",
    oil_change_by: "Schimb ulei efectuat de:",
    scutersh: "Scutersh",
    other_service: "Alt service",
    unknown: "Necunoscut",
    date_last_change: "Data ultimului schimb:",
    km_last_change: "Km la ultimul schimb:",
    intervention_type: "Tip intervenții:",
    periodic: "Periodice",
    rare: "Rare",
    on_demand: "La cerere client",
    docs_title: "SITUAȚIE ACTE & OMOLOGARE",
    docs_available: "Acte disponibile",
    doc_type: "Tip documente:",
    doc_rar: "Carte RAR România",
    doc_foreign: "Carte străinătate (Carte RO la cerere)",
    doc_none: "Fără acte (doar factură)",
    country_docs: "Țara documentelor (dacă străinătate):",
    country_placeholder: "ex: Italia, Germania...",
    doc_notes: "Observații acte:",
    doc_notes_placeholder: "Note despre documente...",
    conclusion: "CONCLUZIE TEHNICĂ",
    general_score: "Scor general (0-5):",
    approved: "Aprobat pentru utilizare",
    mechanic_recommendations: "Recomandări mecanic:",
    recommendations_placeholder: "Notați recomandările...",
    general_observations: "Observații generale",
    observations_placeholder: "Note adiționale despre starea scuterului...",
    legal_note: "Notă legală:",
    legal_text: "Această fișă reflectă starea scuterului la momentul verificării. Uzura ulterioară nu poate fi imputată Scutersh.",
    print_pdf: "Tipărește fișa PDF",
    // Actions
    action_label: "Acțiune:",
    action_none: "-- Selectează --",
    action_schimbat: "Schimbat",
    action_curatat: "Curățat",
    action_inlocuit_nou: "Înlocuit (piesă nouă)",
    action_inlocuit_sh: "Înlocuit (piesă SH)",
    action_completat: "Completat",
    action_la_starea_lui: "La starea lui",
    action_de_comandat: "De comandat",
    add_photo: "Adaugă foto",
    photo_uploading: "Se încarcă...",
    // Categories
    cat_motor: "MOTOR & TRANSMISIE",
    cat_lubrifiere: "LUBRIFIERE & CONSUMABILE",
    cat_franare: "SISTEM DE FRÂNARE",
    cat_roti: "ROȚI & SUSPENSII",
    cat_electric: "SISTEM ELECTRIC",
    cat_cadru: "CADRU & STRUCTURĂ",
    cat_evacuare: "EVACUARE",
    cat_siguranta: "SIGURANȚĂ & CONTROL",
    cat_aspect: "ASPECT GENERAL",
    // Items
    motor_stare_generala: "Motor – stare generală",
    pornire_motor: "Pornire motor (rece/cald)",
    compresie_motor: "Compresie motor",
    zgomote_anormale: "Zgomote anormale",
    pierderi_ulei: "Pierderi ulei",
    ambreiaj: "Ambreiaj",
    curea_transmisie: "Curea transmisie",
    variator: "Variator",
    role_variator: "Role variator",
    cutie_transmisie: "Cutie transmisie",
    nivel_ulei_motor: "Nivel ulei motor",
    calitate_ulei: "Calitate ulei",
    filtru_ulei: "Filtru ulei",
    filtru_aer: "Filtru aer",
    bujie: "Bujie",
    frana_fata: "Frână față",
    frana_spate: "Frână spate",
    placute_frana: "Plăcuțe frână",
    discuri_frana: "Discuri frână",
    conducte_frana: "Conducte frână",
    lichid_frana: "Lichid frână",
    anvelopa_fata: "Anvelopă față",
    anvelopa_spate: "Anvelopă spate",
    presiune_anvelope: "Presiune anvelope",
    jante: "Jante",
    rulmenti_roti: "Rulmenți roți",
    furca_fata: "Furcă față",
    amortizor_spate: "Amortizor spate",
    baterie: "Baterie",
    incarcare_baterie: "Încărcare baterie",
    alternator: "Alternator",
    demaror: "Demaror",
    instalatie_electrica: "Instalație electrică",
    faruri: "Faruri",
    stop: "Stop",
    semnalizari: "Semnalizări",
    claxon: "Claxon",
    bord: "Bord",
    cadru: "Cadru",
    suduri: "Suduri",
    suport_motor: "Suport motor",
    cric: "Cric central/lateral",
    toba_evacuare: "Tobă evacuare",
    garnituri_evacuare: "Garnituri",
    zgomot_evacuare: "Zgomot evacuare",
    ghidon: "Ghidon",
    acceleratie: "Accelerație",
    manete_frana: "Manete frână",
    oglinzi: "Oglinzi",
    blocare_directie: "Blocare direcție",
    carene: "Carene",
    sa: "Șa",
    portbagaj: "Portbagaj / suport",
    stare_generala: "Stare generală",
  },
  ar: {
    code: "ar",
    label: "العربية",
    dir: "rtl",
    // Rating labels
    rating_0: "غير مفحوص / مفقود",
    rating_1: "معطل / يجب استبداله",
    rating_2: "يحتاج إصلاح",
    rating_3: "يعمل",
    rating_4: "حالة جيدة",
    rating_5: "ممتاز",
    // UI
    legend: "مقياس التقييم",
    comment_placeholder: "تعليق...",
    service_info: "معلومات الصيانة",
    last_oil_change: "تم إجراء آخر تغيير زيت",
    oil_change_by: "تغيير الزيت بواسطة:",
    scutersh: "سكوترش",
    other_service: "خدمة أخرى",
    unknown: "غير معروف",
    date_last_change: "تاريخ آخر تغيير:",
    km_last_change: "كم عند آخر تغيير:",
    intervention_type: "نوع التدخلات:",
    periodic: "دورية",
    rare: "نادرة",
    on_demand: "بطلب العميل",
    docs_title: "حالة الوثائق والتسجيل",
    docs_available: "الوثائق متوفرة",
    doc_type: "نوع الوثائق:",
    doc_rar: "بطاقة RAR رومانيا",
    doc_foreign: "بطاقة أجنبية (بطاقة RO عند الطلب)",
    doc_none: "بدون وثائق (فاتورة فقط)",
    country_docs: "بلد الوثائق (إذا أجنبية):",
    country_placeholder: "مثال: إيطاليا، ألمانيا...",
    doc_notes: "ملاحظات الوثائق:",
    doc_notes_placeholder: "ملاحظات حول الوثائق...",
    conclusion: "الخلاصة الفنية",
    general_score: "النتيجة العامة (0-5):",
    approved: "معتمد للاستخدام",
    mechanic_recommendations: "توصيات الميكانيكي:",
    recommendations_placeholder: "اكتب التوصيات...",
    general_observations: "ملاحظات عامة",
    observations_placeholder: "ملاحظات إضافية حول حالة السكوتر...",
    legal_note: "ملاحظة قانونية:",
    legal_text: "تعكس هذه البطاقة حالة السكوتر وقت الفحص. لا يمكن تحميل سكوترش مسؤولية البلى اللاحق.",
    print_pdf: "طباعة PDF",
    // Actions
    action_label: "الإجراء:",
    action_none: "-- اختر --",
    action_schimbat: "تم التغيير",
    action_curatat: "تم التنظيف",
    action_inlocuit_nou: "تم الاستبدال (قطعة جديدة)",
    action_inlocuit_sh: "تم الاستبدال (قطعة مستعملة)",
    action_completat: "تم التكميل",
    action_la_starea_lui: "بحالته",
    action_de_comandat: "يجب الطلب",
    add_photo: "إضافة صورة",
    photo_uploading: "جاري التحميل...",
    // Categories
    cat_motor: "المحرك وناقل الحركة",
    cat_lubrifiere: "التشحيم والمواد الاستهلاكية",
    cat_franare: "نظام الفرامل",
    cat_roti: "العجلات والتعليق",
    cat_electric: "النظام الكهربائي",
    cat_cadru: "الهيكل والبنية",
    cat_evacuare: "العادم",
    cat_siguranta: "السلامة والتحكم",
    cat_aspect: "المظهر العام",
    // Items
    motor_stare_generala: "المحرك - الحالة العامة",
    pornire_motor: "تشغيل المحرك (بارد/ساخن)",
    compresie_motor: "ضغط المحرك",
    zgomote_anormale: "أصوات غير طبيعية",
    pierderi_ulei: "تسرب زيت",
    ambreiaj: "القابض",
    curea_transmisie: "سير ناقل الحركة",
    variator: "المتغير",
    role_variator: "بكرات المتغير",
    cutie_transmisie: "علبة السرعة",
    nivel_ulei_motor: "مستوى زيت المحرك",
    calitate_ulei: "جودة الزيت",
    filtru_ulei: "فلتر الزيت",
    filtru_aer: "فلتر الهواء",
    bujie: "شمعة الإشعال",
    frana_fata: "فرامل أمامية",
    frana_spate: "فرامل خلفية",
    placute_frana: "تيل الفرامل",
    discuri_frana: "أقراص الفرامل",
    conducte_frana: "أنابيب الفرامل",
    lichid_frana: "سائل الفرامل",
    anvelopa_fata: "إطار أمامي",
    anvelopa_spate: "إطار خلفي",
    presiune_anvelope: "ضغط الإطارات",
    jante: "الجنوط",
    rulmenti_roti: "محامل العجلات",
    furca_fata: "الشوكة الأمامية",
    amortizor_spate: "ممتص الصدمات الخلفي",
    baterie: "البطارية",
    incarcare_baterie: "شحن البطارية",
    alternator: "المولد",
    demaror: "بادئ الحركة",
    instalatie_electrica: "التمديدات الكهربائية",
    faruri: "المصابيح الأمامية",
    stop: "مصباح التوقف",
    semnalizari: "إشارات الانعطاف",
    claxon: "البوق",
    bord: "لوحة العدادات",
    cadru: "الإطار",
    suduri: "اللحام",
    suport_motor: "دعامة المحرك",
    cric: "الرافعة المركزية/الجانبية",
    toba_evacuare: "أنبوب العادم",
    garnituri_evacuare: "حشيات العادم",
    zgomot_evacuare: "صوت العادم",
    ghidon: "المقود",
    acceleratie: "دواسة الوقود",
    manete_frana: "مقابض الفرامل",
    oglinzi: "المرايا",
    blocare_directie: "قفل التوجيه",
    carene: "الهيكل الخارجي",
    sa: "المقعد",
    portbagaj: "صندوق الأمتعة",
    stare_generala: "الحالة العامة",
  },
};

// Rating scale (always same colors)
const RATING_LABELS = {
  0: { label: "0", color: "bg-zinc-600" },
  1: { label: "1", color: "bg-red-600" },
  2: { label: "2", color: "bg-orange-500" },
  3: { label: "3", color: "bg-yellow-500" },
  4: { label: "4", color: "bg-lime-500" },
  5: { label: "5", color: "bg-green-500" },
};

const getRatingDesc = (lang, value) => lang[`rating_${value}`] || "";

// Checklist categories and items
export const CHECKLIST_CATEGORIES = [
  {
    id: "motor",
    titleKey: "cat_motor",
    icon: Wrench,
    items: [
      { key: "motor_stare_generala" },
      { key: "pornire_motor" },
      { key: "compresie_motor" },
      { key: "zgomote_anormale" },
      { key: "pierderi_ulei" },
      { key: "ambreiaj" },
      { key: "curea_transmisie" },
      { key: "variator" },
      { key: "role_variator" },
      { key: "cutie_transmisie" },
    ],
  },
  {
    id: "lubrifiere",
    titleKey: "cat_lubrifiere",
    icon: Droplets,
    items: [
      { key: "nivel_ulei_motor" },
      { key: "calitate_ulei" },
      { key: "filtru_ulei" },
      { key: "filtru_aer" },
      { key: "bujie" },
    ],
  },
  {
    id: "franare",
    titleKey: "cat_franare",
    icon: CircleSlash,
    items: [
      { key: "frana_fata" },
      { key: "frana_spate" },
      { key: "placute_frana" },
      { key: "discuri_frana" },
      { key: "conducte_frana" },
      { key: "lichid_frana" },
    ],
  },
  {
    id: "roti",
    titleKey: "cat_roti",
    icon: CircleDot,
    items: [
      { key: "anvelopa_fata" },
      { key: "anvelopa_spate" },
      { key: "presiune_anvelope" },
      { key: "jante" },
      { key: "rulmenti_roti" },
      { key: "furca_fata" },
      { key: "amortizor_spate" },
    ],
  },
  {
    id: "electric",
    titleKey: "cat_electric",
    icon: Zap,
    items: [
      { key: "baterie" },
      { key: "incarcare_baterie" },
      { key: "alternator" },
      { key: "demaror" },
      { key: "instalatie_electrica" },
      { key: "faruri" },
      { key: "stop" },
      { key: "semnalizari" },
      { key: "claxon" },
      { key: "bord" },
    ],
  },
  {
    id: "cadru",
    titleKey: "cat_cadru",
    icon: Box,
    items: [
      { key: "cadru" },
      { key: "suduri" },
      { key: "suport_motor" },
      { key: "cric" },
    ],
  },
  {
    id: "evacuare",
    titleKey: "cat_evacuare",
    icon: Volume2,
    items: [
      { key: "toba_evacuare" },
      { key: "garnituri_evacuare" },
      { key: "zgomot_evacuare" },
    ],
  },
  {
    id: "siguranta",
    titleKey: "cat_siguranta",
    icon: Shield,
    items: [
      { key: "ghidon" },
      { key: "acceleratie" },
      { key: "manete_frana" },
      { key: "oglinzi" },
      { key: "blocare_directie" },
    ],
  },
  {
    id: "aspect",
    titleKey: "cat_aspect",
    icon: Sparkles,
    items: [
      { key: "carene" },
      { key: "sa" },
      { key: "portbagaj" },
      { key: "stare_generala" },
    ],
  },
];

// ==================== RATING BUTTON ====================
const RatingButton = ({ value, selected, onClick }) => {
  const rating = RATING_LABELS[value];
  return (
    <button
      type="button"
      onClick={() => onClick(value)}
      className={cn(
        "w-7 h-7 rounded text-xs font-mono font-bold transition-all duration-200",
        "border hover:scale-110",
        selected 
          ? `${rating.color} text-white border-transparent` 
          : "bg-secondary/50 text-muted-foreground border-transparent hover:border-primary/50"
      )}
      data-testid={`rating-btn-${value}`}
    >
      {value}
    </button>
  );
};

// Action choices for each checklist item
const ACTIONS = [
  { value: "", labelKey: "action_none" },
  { value: "schimbat", labelKey: "action_schimbat" },
  { value: "curatat", labelKey: "action_curatat" },
  { value: "inlocuit_nou", labelKey: "action_inlocuit_nou" },
  { value: "inlocuit_sh", labelKey: "action_inlocuit_sh" },
  { value: "completat", labelKey: "action_completat" },
  { value: "la_starea_lui", labelKey: "action_la_starea_lui" },
  { value: "de_comandat", labelKey: "action_de_comandat" },
];

// ==================== CHECKLIST ITEM WITH COMMENT, ACTION, PHOTOS ====================
const ChecklistItem = ({ item, value, comment, action, photos, onChange, onCommentChange, onActionChange, onPhotoUpload, lang, uploading }) => {
  const t = LANGS[lang] || LANGS.ro;
  const itemLabel = t[item.key] || item.key;
  const isRtl = t.dir === "rtl";

  return (
    <div className={cn("py-2 border-b border-border/50 last:border-0", isRtl && "text-right")} dir={t.dir}>
      {/* Row 1: Label + Rating */}
      <div className="flex items-center justify-between gap-2">
        <span className={cn("text-sm flex-1 font-medium", isRtl ? "pl-2" : "pr-2")}>{itemLabel}</span>
        <div className="flex gap-0.5 flex-shrink-0">
          {[0, 1, 2, 3, 4, 5].map((rating) => (
            <RatingButton
              key={rating}
              value={rating}
              selected={value === rating}
              onClick={onChange}
            />
          ))}
        </div>
      </div>
      {/* Row 2: Action + Comment */}
      <div className="mt-1.5 flex gap-2 items-start flex-wrap">
        <select
          value={action || ""}
          onChange={(e) => onActionChange(e.target.value)}
          className={cn(
            "h-7 px-1.5 text-xs bg-secondary/30 border border-border/50 rounded focus:outline-none focus:ring-1 focus:ring-primary/50",
            "min-w-[140px] max-w-[180px]",
            action === "de_comandat" && "border-orange-500 text-orange-400",
            action === "schimbat" && "border-green-500 text-green-400",
            action === "inlocuit_nou" && "border-blue-500 text-blue-400",
            action === "inlocuit_sh" && "border-cyan-500 text-cyan-400",
          )}
          dir={t.dir}
          data-testid={`action-${item.key}`}
        >
          {ACTIONS.map((a) => (
            <option key={a.value} value={a.value}>{t[a.labelKey] || a.labelKey}</option>
          ))}
        </select>
        <input
          type="text"
          value={comment || ""}
          onChange={(e) => onCommentChange(e.target.value)}
          placeholder={t.comment_placeholder}
          className="flex-1 h-7 px-2 text-xs bg-secondary/30 border border-border/50 rounded focus:outline-none focus:ring-1 focus:ring-primary/50 placeholder:text-muted-foreground/50 min-w-[120px]"
          dir={t.dir}
          data-testid={`comment-${item.key}`}
        />
        <label className={cn(
          "h-7 px-2 flex items-center gap-1 text-xs rounded cursor-pointer border border-dashed border-border/70 hover:border-primary/50 transition-colors",
          uploading && "opacity-50 pointer-events-none"
        )}>
          <Camera className="w-3 h-3" />
          <span className="hidden sm:inline">{uploading ? t.photo_uploading : t.add_photo}</span>
          <input type="file" accept="image/*" capture="environment" className="hidden" onChange={onPhotoUpload} disabled={uploading} />
        </label>
      </div>
      {/* Row 3: Photos preview */}
      {photos && photos.length > 0 && (
        <div className="mt-1.5 flex gap-1.5 flex-wrap">
          {photos.map((url, idx) => (
            <a key={idx} href={url} target="_blank" rel="noreferrer" className="block w-12 h-12 rounded border border-border overflow-hidden hover:ring-2 ring-primary/50 transition-all">
              <img src={url} alt="" className="w-full h-full object-cover" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

// ==================== SERVICE INFO SECTION ====================
const ServiceInfoSection = ({ values, onChange, lang }) => {
  const t = LANGS[lang] || LANGS.ro;
  const serviceInfo = values.service_info || {
    dernier_vidange_effectue: false,
    vidange_effectue_par: "inconnu",
    date_derniere_vidange: "",
    km_derniere_vidange: 0,
    type_interventions: "periodiques"
  };

  const handleServiceChange = (field, value) => {
    onChange({
      ...values,
      service_info: { ...serviceInfo, [field]: value }
    });
  };

  return (
    <div className="bg-secondary/30 rounded-lg p-4 space-y-4" dir={t.dir}>
      <h4 className="font-heading font-bold text-sm uppercase tracking-wide text-primary flex items-center gap-2">
        <Calendar className="w-4 h-4" />
        {t.service_info}
      </h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <Checkbox
              id="vidange_effectue"
              checked={serviceInfo.dernier_vidange_effectue}
              onCheckedChange={(checked) => handleServiceChange("dernier_vidange_effectue", checked)}
            />
            <Label htmlFor="vidange_effectue" className="text-sm">
              {t.last_oil_change}
            </Label>
          </div>
          
          <div className="space-y-2">
            <Label className="text-xs text-muted-foreground">{t.oil_change_by}</Label>
            <Select
              value={serviceInfo.vidange_effectue_par}
              onValueChange={(val) => handleServiceChange("vidange_effectue_par", val)}
            >
              <SelectTrigger className="h-9">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="jedda">{t.scutersh}</SelectItem>
                <SelectItem value="autre">{t.other_service}</SelectItem>
                <SelectItem value="inconnu">{t.unknown}</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        
        <div className="space-y-3">
          <div className="space-y-2">
            <Label className="text-xs text-muted-foreground">{t.date_last_change}</Label>
            <Input
              type="date"
              value={serviceInfo.date_derniere_vidange}
              onChange={(e) => handleServiceChange("date_derniere_vidange", e.target.value)}
              className="h-9"
            />
          </div>
          
          <div className="space-y-2">
            <Label className="text-xs text-muted-foreground">{t.km_last_change}</Label>
            <Input
              type="number"
              value={serviceInfo.km_derniere_vidange}
              onChange={(e) => handleServiceChange("km_derniere_vidange", parseInt(e.target.value) || 0)}
              className="h-9 font-mono"
              placeholder="0"
            />
          </div>
        </div>
      </div>
      
      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">{t.intervention_type}</Label>
        <Select
          value={serviceInfo.type_interventions}
          onValueChange={(val) => handleServiceChange("type_interventions", val)}
        >
          <SelectTrigger className="h-9">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="periodiques">{t.periodic}</SelectItem>
            <SelectItem value="rares">{t.rare}</SelectItem>
            <SelectItem value="a_la_demande">{t.on_demand}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

// ==================== DOCUMENTS SECTION ====================
const DocumentsSection = ({ values, onChange, lang }) => {
  const t = LANGS[lang] || LANGS.ro;
  return (
    <div className="bg-secondary/30 rounded-lg p-4 space-y-4" dir={t.dir}>
      <h4 className="font-heading font-bold text-sm uppercase tracking-wide text-primary flex items-center gap-2">
        <FileText className="w-4 h-4" />
        {t.docs_title}
      </h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <Checkbox
              id="acte_disponibile"
              checked={values.acte_disponibile ?? true}
              onCheckedChange={(checked) => onChange({ ...values, acte_disponibile: checked })}
            />
            <Label htmlFor="acte_disponibile" className="text-sm">
              {t.docs_available}
            </Label>
          </div>
          
          <div className="space-y-2">
            <Label className="text-xs text-muted-foreground">{t.doc_type}</Label>
            <Select
              value={values.tip_acte || "carte_rar"}
              onValueChange={(val) => onChange({ ...values, tip_acte: val })}
            >
              <SelectTrigger className="h-9">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="carte_rar">{t.doc_rar}</SelectItem>
                <SelectItem value="carte_strainatate">{t.doc_foreign}</SelectItem>
                <SelectItem value="fara_acte">{t.doc_none}</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        
        <div className="space-y-3">
          <div className="space-y-2">
            <Label className="text-xs text-muted-foreground">{t.country_docs}</Label>
            <Input
              value={values.tara_documente || ""}
              onChange={(e) => onChange({ ...values, tara_documente: e.target.value })}
              className="h-9"
              placeholder={t.country_placeholder}
            />
          </div>
        </div>
      </div>
      
      <div className="space-y-2">
        <Label className="text-xs text-muted-foreground">{t.doc_notes}</Label>
        <Textarea
          value={values.observatii_acte || ""}
          onChange={(e) => onChange({ ...values, observatii_acte: e.target.value })}
          rows={2}
          placeholder={t.doc_notes_placeholder}
        />
      </div>
    </div>
  );
};

// ==================== CONCLUSION SECTION ====================
const ConclusionSection = ({ values, onChange, lang }) => {
  const t = LANGS[lang] || LANGS.ro;
  return (
    <div className="bg-primary/10 rounded-lg p-4 space-y-4 border border-primary/30" dir={t.dir}>
      <h4 className="font-heading font-bold text-sm uppercase tracking-wide text-primary flex items-center gap-2">
        <Gauge className="w-4 h-4" />
        {t.conclusion}
      </h4>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-3">
          <div className="space-y-2">
            <Label className="text-xs text-muted-foreground">{t.general_score}</Label>
            <div className="flex gap-1">
              {[0, 1, 2, 3, 4, 5].map((rating) => (
                <RatingButton
                  key={rating}
                  value={rating}
                  selected={(values.scor_general ?? 3) === rating}
                  onClick={(val) => onChange({ ...values, scor_general: val })}
                />
              ))}
            </div>
          </div>
          
          <div className="flex items-center gap-3 pt-2">
            <Checkbox
              id="aprobat_utilizare"
              checked={values.aprobat_utilizare ?? true}
              onCheckedChange={(checked) => onChange({ ...values, aprobat_utilizare: checked })}
            />
            <Label htmlFor="aprobat_utilizare" className="text-sm font-bold flex items-center gap-2">
              {values.aprobat_utilizare ? (
                <CheckCircle className="w-4 h-4 text-green-500" />
              ) : (
                <XCircle className="w-4 h-4 text-red-500" />
              )}
              {t.approved}
            </Label>
          </div>
        </div>
        
        <div className="space-y-2">
          <Label className="text-xs text-muted-foreground">{t.mechanic_recommendations}</Label>
          <Textarea
            value={values.recomandari_mecanic || ""}
            onChange={(e) => onChange({ ...values, recomandari_mecanic: e.target.value })}
            rows={3}
            placeholder={t.recommendations_placeholder}
          />
        </div>
      </div>
    </div>
  );
};

// ==================== PDF GENERATION (Always Romanian) ====================
// Strip diacritics for PDF (helvetica doesn't support ș, ț, ă, â, î)
const stripDiacritics = (text) => {
  if (!text) return "";
  return text
    .replace(/[șş]/g, "s").replace(/[ȘŞ]/g, "S")
    .replace(/[țţ]/g, "t").replace(/[ȚŢ]/g, "T")
    .replace(/[ă]/g, "a").replace(/[Ă]/g, "A")
    .replace(/[â]/g, "a").replace(/[Â]/g, "A")
    .replace(/[î]/g, "i").replace(/[Î]/g, "I");
};

const generateMechanicalPDF = (values, scooterInfo) => {
  const ro = LANGS.ro;
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  let y = 15;

  const addLine = (text, x, fontSize = 9, style = "normal") => {
    doc.setFontSize(fontSize);
    doc.setFont("helvetica", style);
    doc.text(text, x, y);
  };

  const checkNewPage = (needed = 20) => {
    if (y + needed > 280) {
      doc.addPage();
      y = 15;
    }
  };

  // Header
  doc.setFillColor(220, 38, 38);
  doc.rect(0, 0, pageWidth, 25, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("SCUTERSH - FISA DE CONTROL MECANIC", pageWidth / 2, 12, { align: "center" });
  doc.setFontSize(9);
  doc.text(`Data: ${new Date().toLocaleDateString("ro-RO")}`, pageWidth / 2, 20, { align: "center" });

  y = 35;
  doc.setTextColor(0, 0, 0);

  // Scooter Info
  if (scooterInfo) {
    doc.setFillColor(245, 245, 245);
    doc.rect(10, y - 5, pageWidth - 20, 18, "F");
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`${scooterInfo.brand || ""} ${scooterInfo.model || ""} (${scooterInfo.year || ""})`, 14, y + 2);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`ID: ${scooterInfo.scooter_id || ""} | VIN: ${scooterInfo.vin || ""} | Km: ${scooterInfo.mileage || ""}`, 14, y + 9);
    y += 20;
  }

  // Rating legend
  const ratingColors = {
    0: [113, 113, 122], 1: [220, 38, 38], 2: [234, 88, 12],
    3: [202, 138, 4], 4: [132, 204, 22], 5: [22, 163, 74]
  };
  
  doc.setFontSize(7);
  doc.setFont("helvetica", "italic");
  let legendX = 14;
  for (let i = 0; i <= 5; i++) {
    const [r, g, b] = ratingColors[i];
    doc.setFillColor(r, g, b);
    doc.circle(legendX, y, 2.5, "F");
    doc.setTextColor(255, 255, 255);
    doc.text(String(i), legendX - 1, y + 1);
    doc.setTextColor(0, 0, 0);
    doc.text(` ${stripDiacritics(ro[`rating_${i}`])}`, legendX + 4, y + 1);
    legendX += 30;
  }
  y += 8;

  // Categories & Items
  CHECKLIST_CATEGORIES.forEach((category) => {
    checkNewPage(30);
    
    // Category header
    doc.setFillColor(30, 30, 30);
    doc.rect(10, y - 4, pageWidth - 20, 7, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text(stripDiacritics(ro[category.titleKey] || category.titleKey), 14, y);
    y += 7;
    doc.setTextColor(0, 0, 0);

    category.items.forEach((item) => {
      checkNewPage(12);
      const rating = values[item.key] ?? 3;
      const comment = values[`${item.key}_comment`] || "";
      const itemLabel = ro[item.key] || item.key;

      // Item label
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text(stripDiacritics(itemLabel), 14, y);

      // Rating circle
      const [r, g, b] = ratingColors[rating] || [113, 113, 122];
      doc.setFillColor(r, g, b);
      doc.circle(130, y - 1.5, 3, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(7);
      doc.setFont("helvetica", "bold");
      doc.text(String(rating), 129, y - 0.5);
      doc.setTextColor(0, 0, 0);

      // Rating description + action
      doc.setFontSize(7);
      doc.setFont("helvetica", "italic");
      const actionKey = values[`${item.key}_action`] || "";
      const actionRoLabels = { schimbat: "Schimbat", curatat: "Curatat", inlocuit_nou: "Inlocuit (piesa noua)", inlocuit_sh: "Inlocuit (piesa SH)", completat: "Completat", la_starea_lui: "La starea lui", de_comandat: "De comandat" };
      const ratingAndAction = stripDiacritics(ro[`rating_${rating}`] || "") + (actionKey ? ` | ${actionRoLabels[actionKey] || actionKey}` : "");
      doc.text(ratingAndAction, 136, y);

      // Comment
      if (comment) {
        y += 4;
        checkNewPage(8);
        doc.setFontSize(7);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100, 100, 100);
        const lines = doc.splitTextToSize(`> ${stripDiacritics(comment)}`, pageWidth - 30);
        doc.text(lines, 18, y);
        y += lines.length * 3.5;
        doc.setTextColor(0, 0, 0);
      }

      y += 5;
    });
    y += 3;
  });

  // Conclusion
  checkNewPage(40);
  doc.setFillColor(220, 38, 38);
  doc.rect(10, y - 4, pageWidth - 20, 7, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.text("CONCLUZIE TEHNICA", 14, y);
  y += 10;
  doc.setTextColor(0, 0, 0);

  doc.setFontSize(9);
  doc.text(`Scor general: ${values.scor_general ?? 3}/5`, 14, y);
  y += 5;
  doc.text(`Aprobat pentru utilizare: ${values.aprobat_utilizare !== false ? "DA" : "NU"}`, 14, y);
  y += 5;

  if (values.recomandari_mecanic) {
    doc.text("Recomandari mecanic:", 14, y);
    y += 4;
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    const recLines = doc.splitTextToSize(stripDiacritics(values.recomandari_mecanic), pageWidth - 30);
    doc.text(recLines, 18, y);
    y += recLines.length * 4;
  }

  if (values.observations) {
    y += 3;
    checkNewPage(20);
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text("Observatii generale:", 14, y);
    y += 4;
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    const obsLines = doc.splitTextToSize(stripDiacritics(values.observations), pageWidth - 30);
    doc.text(obsLines, 18, y);
    y += obsLines.length * 4;
  }

  // Signature line
  checkNewPage(30);
  y += 10;
  doc.setDrawColor(0, 0, 0);
  doc.line(14, y, 80, y);
  doc.line(pageWidth - 80, y, pageWidth - 14, y);
  y += 5;
  doc.setFontSize(8);
  doc.text("Semnatura mecanic", 14, y);
  doc.text("Data", pageWidth - 80, y);

  // Footer
  y += 8;
  doc.setFontSize(6);
  doc.setTextColor(150, 150, 150);
  doc.text("Aceasta fisa reflecta starea scuterului la momentul verificarii. Uzura ulterioara nu poate fi imputata Scutersh.", 14, y);

  const scooterName = scooterInfo ? `${scooterInfo.scooter_id}_${scooterInfo.brand}_${scooterInfo.model}`.replace(/\s+/g, "_") : "scooter";
  doc.save(`Fisa_Mecanica_${scooterName}.pdf`);
};

// ==================== FULL CHECKLIST FORM ====================
export const MechanicalChecklistForm = ({ values, onChange, scooterInfo }) => {
  const [lang, setLang] = useState("ro");
  const [uploadingKey, setUploadingKey] = useState(null);
  const t = LANGS[lang] || LANGS.ro;

  const handleChange = (key, value) => {
    onChange({ ...values, [key]: value });
  };

  const handleCommentChange = (key, comment) => {
    onChange({ ...values, [`${key}_comment`]: comment });
  };

  const handleActionChange = (key, action) => {
    onChange({ ...values, [`${key}_action`]: action });
    // If "de_comandat", create parts order automatically (only if not already ordered)
    if (action === "de_comandat" && scooterInfo) {
      // Check if already ordered to prevent duplicates
      const prevAction = values[`${key}_action`];
      if (prevAction === "de_comandat") return; // Already set, skip duplicate
      const ro = LANGS.ro;
      const itemLabel = ro[key] || key;
      import("@/lib/api").then(({ default: api }) => {
        api.post("/mechanic-parts-orders", {
          scooter_id: scooterInfo.scooter_id,
          scooter_brand: scooterInfo.brand || "",
          scooter_model: scooterInfo.model || "",
          scooter_code: scooterInfo.scooter_id,
          item_key: key,
          item_label: itemLabel,
          notes: values[`${key}_comment`] || "",
        }).then(() => {
          import("sonner").then(({ toast }) => toast.success(`Piesa "${itemLabel}" adaugata la comenzi`));
        }).catch((err) => console.error("Parts order creation error:", err));
      });
    }
  };

  const handlePhotoUpload = async (key, file) => {
    if (!file || !scooterInfo) return;
    setUploadingKey(key);
    try {
      const { default: api } = await import("@/lib/api");
      const formData = new FormData();
      formData.append("file", file);
      const resp = await api.post(`/scooters/${scooterInfo.scooter_id}/mechanic-photos/${key}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const url = resp.data.url;
      const photosKey = `${key}_photos`;
      const currentPhotos = values[photosKey] || [];
      onChange({ ...values, [photosKey]: [...currentPhotos, url] });
      const { toast } = await import("sonner");
      toast.success("Foto incarcata");
    } catch (err) {
      const { toast } = await import("sonner");
      toast.error("Eroare la incarcare foto");
    } finally {
      setUploadingKey(null);
    }
  };

  return (
    <div className="space-y-6" dir={t.dir}>
      {/* Language Toggle + Print */}
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <Languages className="w-4 h-4 text-muted-foreground" />
          <div className="flex rounded-lg overflow-hidden border border-border">
            {Object.entries(LANGS).map(([code, langDef]) => (
              <button
                key={code}
                type="button"
                onClick={() => setLang(code)}
                className={cn(
                  "px-3 py-1.5 text-xs font-medium transition-colors",
                  lang === code
                    ? "bg-primary text-primary-foreground"
                    : "bg-secondary/50 text-muted-foreground hover:bg-secondary"
                )}
                data-testid={`lang-toggle-${code}`}
              >
                {langDef.label}
              </button>
            ))}
          </div>
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => generateMechanicalPDF(values, scooterInfo)}
          data-testid="print-mechanical-pdf"
        >
          <Printer className="w-4 h-4 mr-2" />
          {t.print_pdf}
        </Button>
      </div>

      {/* Rating Legend */}
      <div className="bg-secondary/50 rounded-lg p-3">
        <p className="text-xs text-muted-foreground uppercase tracking-wide mb-2">
          {t.legend}
        </p>
        <div className="flex flex-wrap gap-2">
          {Object.entries(RATING_LABELS).map(([value, { color }]) => (
            <div key={value} className="flex items-center gap-1">
              <span className={cn("w-5 h-5 rounded text-xs font-mono font-bold flex items-center justify-center text-white", color)}>
                {value}
              </span>
              <span className="text-xs text-muted-foreground">{getRatingDesc(t, value)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Service Info */}
      <ServiceInfoSection values={values} onChange={onChange} lang={lang} />

      {/* Categories */}
      {CHECKLIST_CATEGORIES.map((category) => (
        <div key={category.id} className="space-y-2">
          <h4 className="font-heading font-bold text-sm uppercase tracking-wide text-primary flex items-center gap-2">
            <category.icon className="w-4 h-4" />
            {t[category.titleKey] || category.titleKey}
          </h4>
          <div className="bg-card rounded-lg border border-border p-3">
            {category.items.map((item) => (
              <ChecklistItem
                key={item.key}
                item={item}
                value={values[item.key] ?? 3}
                comment={values[`${item.key}_comment`] || ""}
                action={values[`${item.key}_action`] || ""}
                photos={values[`${item.key}_photos`] || []}
                onChange={(val) => handleChange(item.key, val)}
                onCommentChange={(c) => handleCommentChange(item.key, c)}
                onActionChange={(a) => handleActionChange(item.key, a)}
                onPhotoUpload={(e) => e.target.files[0] && handlePhotoUpload(item.key, e.target.files[0])}
                uploading={uploadingKey === item.key}
                lang={lang}
              />
            ))}
          </div>
        </div>
      ))}

      {/* Technical Conclusion */}
      <ConclusionSection values={values} onChange={onChange} lang={lang} />

      {/* AI Mechanic Assistant */}
      {scooterInfo && (
        <div className="bg-gradient-to-r from-orange-500/10 to-red-500/10 rounded-lg p-4 border border-orange-500/30">
          <h4 className="font-heading font-bold text-sm uppercase tracking-wide text-orange-400 flex items-center gap-2 mb-3">
            <span className="w-5 h-5 rounded bg-orange-500 flex items-center justify-center text-white text-[10px] font-bold">AI</span>
            DIAGNOSTIC AI MECANIC
          </h4>
          <AIMechanicButton scooterId={scooterInfo.scooter_id} additionalContext={values.observations || ""} />
        </div>
      )}

      {/* Documents */}
      <DocumentsSection values={values} onChange={onChange} lang={lang} />

      {/* General Observations */}
      <div className="space-y-2" dir={t.dir}>
        <Label>{t.general_observations}</Label>
        <Textarea
          value={values.observations || ""}
          onChange={(e) => handleChange("observations", e.target.value)}
          rows={4}
          placeholder={t.observations_placeholder}
          dir={t.dir}
        />
      </div>

      {/* Legal Note */}
      <div className="bg-muted/50 rounded-lg p-3 text-xs text-muted-foreground" dir={t.dir}>
        <p className="font-bold mb-1">{t.legal_note}</p>
        <p>{t.legal_text}</p>
      </div>
    </div>
  );
};

// ==================== DISPLAY COMPONENT (Read-only) ====================
export const MechanicalChecklistDisplay = ({ values }) => {
  if (!values) return null;

  const ro = LANGS.ro;
  const getRatingColor = (value) => RATING_LABELS[value]?.color || "bg-zinc-600";
  const serviceInfo = values.service_info || {};

  return (
    <div className="space-y-6">
      {/* Rating Legend */}
      <div className="bg-secondary/50 rounded-lg p-3">
        <div className="flex flex-wrap gap-2 justify-center">
          {Object.entries(RATING_LABELS).map(([value, { color }]) => (
            <div key={value} className="flex items-center gap-1">
              <span className={cn("w-5 h-5 rounded text-xs font-mono font-bold flex items-center justify-center text-white", color)}>
                {value}
              </span>
              <span className="text-xs text-muted-foreground">{getRatingDesc(ro, value)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Service Info Display */}
      {(serviceInfo.dernier_vidange_effectue || serviceInfo.date_derniere_vidange) && (
        <div className="bg-secondary/30 rounded-lg p-3">
          <h4 className="font-bold text-xs uppercase tracking-wide text-primary mb-2 flex items-center gap-2">
            <Calendar className="w-3 h-3" />
            INFO SERVICE
          </h4>
          <div className="grid grid-cols-2 gap-2 text-xs">
            {serviceInfo.dernier_vidange_effectue && (
              <div>
                <span className="text-muted-foreground">Vidange:</span>
                <span className="ml-1 text-green-500">&#10003; Efectuat</span>
              </div>
            )}
            {serviceInfo.vidange_effectue_par && serviceInfo.vidange_effectue_par !== "inconnu" && (
              <div>
                <span className="text-muted-foreground">De:</span>
                <span className="ml-1">{serviceInfo.vidange_effectue_par === "jedda" ? "Scutersh" : "Alt service"}</span>
              </div>
            )}
            {serviceInfo.date_derniere_vidange && (
              <div>
                <span className="text-muted-foreground">Data:</span>
                <span className="ml-1 font-mono">{serviceInfo.date_derniere_vidange}</span>
              </div>
            )}
            {serviceInfo.km_derniere_vidange > 0 && (
              <div>
                <span className="text-muted-foreground">Km:</span>
                <span className="ml-1 font-mono">{serviceInfo.km_derniere_vidange.toLocaleString()}</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Categories Display */}
      {CHECKLIST_CATEGORIES.map((category) => (
        <div key={category.id}>
          <h4 className="font-bold text-xs uppercase tracking-wide text-primary mb-2 flex items-center gap-2">
            <category.icon className="w-3 h-3" />
            {ro[category.titleKey] || category.titleKey}
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
            {category.items.map((item) => {
              const value = values[item.key] ?? 3;
              const comment = values[`${item.key}_comment`] || "";
              const action = values[`${item.key}_action`] || "";
              const photos = values[`${item.key}_photos`] || [];
              const actionLabels = { schimbat: "Schimbat", curatat: "Curatat", inlocuit_nou: "Inlocuit (nou)", inlocuit_sh: "Inlocuit (SH)", completat: "Completat", la_starea_lui: "La starea lui", de_comandat: "De comandat" };
              return (
                <div key={item.key} className="p-1.5 bg-secondary/30 rounded text-xs">
                  <div className="flex items-center justify-between">
                    <span className="truncate pr-1">{ro[item.key] || item.key}</span>
                    <div className="flex items-center gap-1 flex-shrink-0">
                      {action && (
                        <span className={cn("px-1.5 py-0.5 rounded text-[9px] font-medium",
                          action === "de_comandat" ? "bg-orange-500/20 text-orange-400" :
                          action === "schimbat" || action === "inlocuit_nou" ? "bg-green-500/20 text-green-400" :
                          "bg-blue-500/20 text-blue-400"
                        )}>
                          {actionLabels[action] || action}
                        </span>
                      )}
                      <span className={cn("w-5 h-5 rounded text-xs font-mono font-bold flex items-center justify-center text-white", getRatingColor(value))}>
                        {value}
                      </span>
                    </div>
                  </div>
                  {comment && (
                    <p className="text-muted-foreground mt-0.5 italic text-[10px]">{comment}</p>
                  )}
                  {photos.length > 0 && (
                    <div className="flex gap-1 mt-1">
                      {photos.map((url, idx) => (
                        <a key={idx} href={url} target="_blank" rel="noreferrer" className="block w-8 h-8 rounded overflow-hidden border border-border">
                          <img src={url} alt="" className="w-full h-full object-cover" />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {/* Conclusion Display */}
      <div className="bg-primary/10 rounded-lg p-3 border border-primary/30">
        <div className="flex items-center justify-between">
          <div>
            <span className="text-xs text-muted-foreground">Scor general:</span>
            <span className={cn(
              "ml-2 px-2 py-0.5 rounded text-sm font-bold",
              getRatingColor(values.scor_general ?? 3),
              "text-white"
            )}>
              {values.scor_general ?? 3}/5
            </span>
          </div>
          <div className="flex items-center gap-2">
            {values.aprobat_utilizare !== false ? (
              <span className="flex items-center gap-1 text-green-500 text-sm font-bold">
                <CheckCircle className="w-4 h-4" />
                APROBAT
              </span>
            ) : (
              <span className="flex items-center gap-1 text-red-500 text-sm font-bold">
                <XCircle className="w-4 h-4" />
                NEAPROBAT
              </span>
            )}
          </div>
        </div>
        {values.recomandari_mecanic && (
          <div className="mt-2 pt-2 border-t border-primary/20">
            <p className="text-xs text-muted-foreground">Recomandari:</p>
            <p className="text-sm">{values.recomandari_mecanic}</p>
          </div>
        )}
      </div>

      {/* Documents Display */}
      <div className="bg-secondary/30 rounded-lg p-3">
        <h4 className="font-bold text-xs uppercase tracking-wide text-primary mb-2 flex items-center gap-2">
          <FileText className="w-3 h-3" />
          SITUATIE ACTE
        </h4>
        <div className="grid grid-cols-2 gap-2 text-xs">
          <div>
            <span className="text-muted-foreground">Acte:</span>
            <span className={cn("ml-1", values.acte_disponibile !== false ? "text-green-500" : "text-red-500")}>
              {values.acte_disponibile !== false ? "\u2713 Disponibile" : "\u2717 Indisponibile"}
            </span>
          </div>
          <div>
            <span className="text-muted-foreground">Tip:</span>
            <span className="ml-1">
              {values.tip_acte === "carte_rar" ? "Carte RAR" : 
               values.tip_acte === "carte_strainatate" ? "Carte strainatate" : 
               "Fara acte"}
            </span>
          </div>
          {values.tara_documente && (
            <div>
              <span className="text-muted-foreground">Tara:</span>
              <span className="ml-1">{values.tara_documente}</span>
            </div>
          )}
        </div>
        {values.observatii_acte && (
          <p className="mt-2 text-xs text-muted-foreground">{values.observatii_acte}</p>
        )}
      </div>

      {/* Observations */}
      {values.observations && (
        <div className="border-t border-border pt-3">
          <p className="text-xs text-muted-foreground uppercase tracking-wide mb-1">
            Observatii generale
          </p>
          <p className="text-sm whitespace-pre-wrap">{values.observations}</p>
        </div>
      )}
    </div>
  );
};

// ==================== UTILITIES ====================
export const calculateAverageScore = (values) => {
  if (!values) return 0;
  const keys = CHECKLIST_CATEGORIES.flatMap(c => c.items.map(i => i.key));
  const scores = keys.map(k => values[k] ?? 3);
  const sum = scores.reduce((a, b) => a + b, 0);
  return (sum / scores.length).toFixed(1);
};

export const getOverallCondition = (avgScore) => {
  if (avgScore >= 4.5) return { label: "Excelent", color: "text-green-500" };
  if (avgScore >= 3.5) return { label: "Bun", color: "text-lime-500" };
  if (avgScore >= 2.5) return { label: "Acceptabil", color: "text-yellow-500" };
  if (avgScore >= 1.5) return { label: "De reparat", color: "text-orange-500" };
  return { label: "Defect", color: "text-red-500" };
};
